import React, { Dispatch } from 'react';
import Translator from '../../../core/i18n';
import { Log } from 'ng2-logger';
import DocumentActivityCard from '../activity-cards/document/main';
import { IActivityCard, IActivityCardItems } from '../../../models/components/activity-card';
import { IAppState, IAction } from '../../../models/action/core';
import { connect } from 'react-redux';
import { ActivityType } from '../../../models/enums/ActivityType';
import Loading from '../../loading/loading';
import SurveyActivityCard from '../activity-cards/survey/main';
import CVideoActivityCard from '../activity-cards/video/main';
import LinkActivityCard from '../activity-cards/link/main';
import ForumActivityCard from '../activity-cards/forum/main';
import Elesson from '../activity-cards/elesson/main';
import ProjectActivityCard from '../activity-cards/project/main';
import ExamActivityCard from '../activity-cards/exam/main';
import DefaultActivityCard from '../activity-cards/default';
import * as Actions from '../../../store/actions/coursePage';
import { CourseContentMenuType } from '../../../models/enums/CourseContentMenuType';
import AssignmentActivityCard from './assignment/main';
import VirtualClass from './virtualClass/main';
import { enrollmentStatus } from '../../../models/enums/enrollmentStatus';
import BaseModal from '../../../modal/base-modal/main';
import SendAssignmentModal from '../../../modal/in-modal/send-assignment/main';
import { Common } from '../../../core/common';
import { UserType } from '../../../models/enums/userType';
import ContentLoader from 'react-content-loader';
import ActivityFilters from './filters';
import CInformationNoteActivityCard from './information-note/main';
import { CourseDefaultViewType } from '../../../models/enums/CourseDefaultViewType';
import imgAnn from '../../../static/images/announcement.svg';
import CInComingActivities from '../incoming-activities/main';
import CAnnouncements from '../../announcements/main';
import LoginAnnouncementModal from '../../../modal/in-modal/login-announcement/main';
import FilterModal from '../../../components/popup/filter-modal';
import CourseContentSelectionMenu from '../course-content-selection-vertical-menu/main';

import CActivityProgress from '../activity-progress/main';
import { DateCriteria } from '../../../models/enums/dateCriteria';
import ReactGA from 'react-ga4';
import { CoursePageService } from '../../../api/course-page-service';
import * as EnrollmentActions from '../../../store/actions/enrollment';
import Tooltip from '../../tooltip/main';
import { Notification } from '../../notification/main';
import { Button } from '../../ui-elements/main';
import { ModuleItems } from '../../../models/enums/moduleItems';

const _logger = Log.create('ActivityCardMain.tsx');
const T = Translator.create();
let _common: Common;
let scrollListenner: any;
let activity_card: Array<any> = new Array<any>();
let next_activity_card: any;
let isChanged: boolean = false;
let activity_card_list_view: Array<any> = new Array<any>();
let old_activity_card: Array<any> = new Array<any>();
let old_activity_card_list_view: Array<any> = new Array<any>();
const coursePageService = new CoursePageService();

class ActivityCardContainer extends React.Component<IActivityCard, any> {
    renderedCount = 0;
    state = {
        isModalOpen: false,
        assignmentActivityCard: null,
        showMoreCount: 5,
        showMobile: false,
        courseDefaultView: this.props.classId?.courseDefaultView ? this.props.classId?.courseDefaultView : CourseDefaultViewType.Card,
        weeklyTerm: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks?.length > 1,
        loaded: false,
        refreshCardListView: true,
        refreshCardView: true,
        hasFilterChanged: false,
        selectedWeeks: [] as any,
        isAnnouncementModalOpen: false,
        modalHeaderData: '',
        filterModalOpen: false,
        filterData: [] as any,
        rendered: false,
        isFirstLoad: true,
        filters: {
            searchedText: '',
            selectedActivityTypes: [],
            sort: this.props.sort ?? '-',
            hasFilter: false,
            GetOnlyPassiveList: false,
        },
        statusFilter: -1,
        nonWeeklyCourse: this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length === 1,
        isLoading: false,
        defaultViewClicked: false,
        isFileExist: false,
    };
    delayTimer: any;

    constructor(props: any) {
        super(props);
        _common = new Common();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
        activity_card = [];
        activity_card_list_view = [];
        next_activity_card = undefined;
        const _filters = {
            searchedText: '',
            selectedActivityTypes: [],
            sort: this.props.sort ?? '-',
            hasFilter: false,
            GetOnlyPassiveList: false,
        };

        this.setState({ filters: _filters, sorting: '-' });
        this.props.dispatch(Actions.setActivityFiltersAction({
            selectedActivityTypes: [],
            searchedText: '',
            sort: this.props.sort ?? '-',
            hasFilter: false
        }));

        this.setState({ defaultViewClicked: false })

    }

    handleBeforeUnload = (event: any) => {
        if (!this.state.isFileExist) {
            return;
        }

        event.preventDefault();
        event.returnValue = '';
    };

    triggerSendAssignmentModal = (activityCardItem?: IActivityCardItems) => {
        if (this.state.isFileExist) {
            Notification.setNotification("info", T.t("r_cannot_close_without_saving_assignment"), 'topRight');
        } else {
            this.setState({
                ...this.state,
                isModalOpen: !this.state.isModalOpen,
                assignmentActivityCard: activityCardItem ? activityCardItem : null
            });
        }
    };

    public headerState = (value: string) => {
        if (value) {
            this.setState({ modalHeaderData: value });
        }
    }

    public callBackFunction = (value: boolean) => {
        if (value) {
            this.setState({ isFileExist: false }, () => {
                this.triggerSendAssignmentModal();
            })
        }
    };

    public componentWillMount = () => {
        if (this.props.courseContentWeekActivities && this.props.courseContentWeekActivities.length > 4 && this.props.actId) {
            const getFindElement = this.props.courseContentWeekActivities.find(x => x.activityId === this.props.actId);
            if (getFindElement) {
                const getWeekActivityIndex = this.props.courseContentWeekActivities.indexOf(getFindElement);

                this.state.showMoreCount = getWeekActivityIndex + 5;
            }
        }

    };

    public componentDidMount = () => {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 1) {
            this.setState({ weeklyTerm: true })
        }

        if (this.props.classId && (this.props.classId.courseDefaultView || this.props.classId.courseDefaultView === CourseDefaultViewType.Card) && this.state.weeklyTerm) {
            this.setState({ courseDefaultView: this.props.classId.courseDefaultView })
            this.changeCourseDefaultView(this.props.classId.courseDefaultView, "1")
        }
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        window.addEventListener("resize", this.handleResize);
        this.handleResize();
        scrollListenner = document.getElementById("activities-tab");
        scrollListenner!.addEventListener("scroll", this.trackScrolling);
        this.state.showMoreCount = 5
        const parsedUrl = new URL(window.location.href);
        let type = '';
        if (parsedUrl.search.includes('type=1')) {
            let typePart = parsedUrl.search.split('&type=')[1]
            type = typePart.split('&actid')[0]
        }

        this.setState(this.state);
        if (activity_card && activity_card.length > 0) {
            activity_card = [];
            activity_card_list_view = [];
            next_activity_card = undefined;
        }

    };

    setFiltersAfterActivityAdding = (prevProps: any) => {
        if (this.props.activityIdAfterAdd !== prevProps.activityIdAfterAdd && this.props.activityIdAfterAdd) {
            const _filters = {
                searchedText: '',
                selectedActivityTypes: [],
                sort: this.props.sort ?? '-',
                hasFilter: false,
                GetOnlyPassiveList: false,
            };

            this.setState({ filters: _filters, sorting: '-' });
        }
    }

    setWeeklyStates = (prevProps: any) => {
        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks) {
            if (this.props.courseContentTermWeeks.length > 1) {
                this.setState({ weeklyTerm: true })

            }
            else if (this.props.courseContentTermWeeks.length === 1) {
                this.setState({ nonWeeklyCourse: true })

            }
        }
    }

    componentDidUpdate(prevProps: Readonly<IActivityCard>, prevState: Readonly<any>, snapshot?: any): void {


        if (this.props.courseContentTermWeeks !== prevProps.courseContentTermWeeks && this.props.courseContentTermWeeks && this.props.courseContentTermWeeks.length > 1) {
            this.setState({ weeklyTerm: true })
        }

        this.refreshCourseDefaultViewType(prevProps, prevState)

        if (isChanged) {
            this.whenCoursePageActivityIsChanged(prevState)

        }

        if (this.props.hasFilter !== prevProps.hasFilter && !this.state.hasFilterChanged) {
            this.setState({ hasFilterChanged: true })
        }

        if (!this.state.rendered) {
            this.setState({ rendered: true })
        }

        if (this.props.getMoreActivities !== prevProps.getMoreActivities && this.props.getMoreActivities) {
            this.setState((prevstate: any) => ({
                ...prevstate,
                showMoreCount: prevstate.showMoreCount + 5
            }));
            this.props.dispatch(Actions.SetGetMoreActivities(false))
        }

        this.setFiltersAfterActivityAdding(prevProps);

        this.setWeeklyStates(prevProps);

        if (this.state.weeklyTerm !== prevState.weeklyTerm && this.state.weeklyTerm && this.props.courseDefaultView === CourseDefaultViewType.List) {
            this.onFilter();

        }

        if (this.props.courseDefaultView !== prevProps.courseDefaultView && this.state.weeklyTerm && this.props.courseDefaultView === CourseDefaultViewType.List && !this.state.loaded) {
            this.onFilter();
        }

        if (this.props.actId != prevProps.actId) {
            const _filters = {
                searchedText: '',
                selectedActivityTypes: [],
                sort: this.props.sort ?? '-',
                hasFilter: false,
                GetOnlyPassiveList: false,
            };
            this.setState({ filters: _filters, sorting: '-', filterData: [] });
        }


    }

    refreshCourseDefaultViewType = (prevProps: any, prevState: any) => {
        if (this.props.classId && (this.props.classId.courseDefaultView || this.props.classId.courseDefaultView === CourseDefaultViewType.Card) && prevProps.classId && prevProps.classId.courseDefaultView !== this.props.classId.courseDefaultView && this.state.weeklyTerm) {
            this.changeCourseDefaultView(this.props.classId.courseDefaultView, "1")
        }

        if (this.state.weeklyTerm !== prevState.weeklyTerm && this.state.weeklyTerm && this.props.classId) {
            this.changeCourseDefaultView(this.props.classId.courseDefaultView, "1")
        }
        if (prevProps.coursePageClassId !== this.props.coursePageClassId && this.props.coursePageClassId && this.props.classId) {
            this.changeCourseDefaultView(this.props.classId.courseDefaultView, "1")

        }
    }

    whenCoursePageActivityIsChanged = (prevState: any) => {
        isChanged = false
        if (this.state.courseDefaultView === prevState.courseDefaultView && this.state.courseDefaultView === CourseDefaultViewType.List) {
            this.setState({ refreshCardListView: true })

        }

        if (this.state.loaded) {
            if (this.state.courseDefaultView === prevState.courseDefaultView && this.state.courseDefaultView === CourseDefaultViewType.List) {
                this.setState({ refreshCardListView: true })
            }
            else {
                this.setState({ refreshCardListView: false })

            }

            if (this.state.courseDefaultView === prevState.courseDefaultView && this.state.courseDefaultView === CourseDefaultViewType.Card) {
                this.setState({ refreshCardView: true })
            }
        }
        else if (((this.state.courseDefaultView === prevState.courseDefaultView) || (this.props.classId.courseDefaultView === CourseDefaultViewType.List && this.state.courseDefaultView !== prevState.courseDefaultView)) && this.state.courseDefaultView === CourseDefaultViewType.Card) {
            this.setState({ refreshCardView: true })
        }
    }

    updateFilterData = (data: any) => {
        this.setState({ filterData: data })
    }

    handleResize = () => {
        setTimeout(() => {
            const showMobile = window.innerWidth < 1024;
            if (showMobile !== this.state.showMobile) {
                this.setState({ showMobile });
            }
        }, 0);
    };
    public selectedAssignment = (data: any) => {
        if (data) {
            this.setState({ selectedActivity: data });
        }
    }

    public showMoreOnClick = (event: React.MouseEvent<HTMLDivElement>) => {

        this.setState({
            ...this.state,
            showMoreCount: this.state.showMoreCount + 5
        });
    };

    trackScrolling = () => {
        const els = document.getElementsByClassName('activity-card-scroll');

        const elsArray = Array.from(els);
        const arrayActivities = [];
        for (const el of elsArray) {
            let activityId = el.id.replace('activity-card-', '')
            let filteredActivity = this.props.activityCard?.find(act => act.activityId === activityId && act.termWeekIds?.includes(this.props.weekOrUnitId!))
            if (filteredActivity || !this.state.weeklyTerm) {
                arrayActivities.push({ top: el.getBoundingClientRect().top, Id: el.id.replace('activity-card-', '') });

            }
        }

        if (arrayActivities.length > 0) {
            const currentDivElement = arrayActivities.filter(f => f.top > 0).sort((a, b) => b.top - a.top)[0];

            if (currentDivElement && (arrayActivities[arrayActivities.length - 1].Id === currentDivElement.Id)) {

                this.setState({
                    ...this.state,
                    showMoreCount: this.state.showMoreCount + 5
                });
            }
        }
        if (arrayActivities.length > 1) {
            const currentDivElement = arrayActivities.filter(f => f.top > 0).sort((a, b) => a.top - b.top)[0];
            if (currentDivElement && (arrayActivities[arrayActivities.length - 1].Id === currentDivElement.Id || arrayActivities[arrayActivities.length - 2].Id === currentDivElement.Id)) {
                this.setState({
                    ...this.state,
                    showMoreCount: this.state.showMoreCount + 5
                });
            }
        }

        scrollListenner!.removeEventListener("scroll", this.trackScrolling);

        scrollListenner!.addEventListener("scroll", this.trackScrolling);
    };

    public returnActivityCardComponent = (activityType: ActivityType, activityCard: IActivityCardItems) => {

        if (this.props.enrollmentData) {
            const enrollmentData = this.props.enrollmentData.find(x => x.activityId === activityCard.activityId);
            if (enrollmentData !== undefined) {
                activityCard.enrollmentStatus = enrollmentData.status;
                activityCard.enrollmentProgress = enrollmentData.progress;
                activityCard.enrollmentTotalSecond = activityType === ActivityType.Elesson ? enrollmentData.eLessonTotalSeconds! : enrollmentData.totalSeconds;
                activityCard.enrollmentReplaySecond = enrollmentData.replaySeconds;
                activityCard.enrollmentVirtualClassLiveProgress = enrollmentData.virtualClassLiveProgress;
                activityCard.enrollmentVirtualClassReplayProgress = enrollmentData.virtualClassReplayProgress;
                activityCard.enrollmentId = enrollmentData.enrollmentId;
                activityCard.enrollmentAssignmentUploadedCount = enrollmentData.uploadCount;
                activityCard.enrollmentScore = enrollmentData.score;
                activityCard.classId = this.props.coursePageClassId;
                activityCard = { ...activityCard };
            }
        }

        switch (activityType) {
            case ActivityType.Document:
            case ActivityType.Reading: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <DocumentActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />

                    </div>
                );
            }
            case ActivityType.Survey: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <SurveyActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.Assignment: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <AssignmentActivityCard
                            activityCard={activityCard} sendAssignmentModalOpen={this.triggerSendAssignmentModal} classId={this.props.coursePageClassId}
                        />

                    </div >
                );
            }
            case ActivityType.Video: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <CVideoActivityCard hasFilter={this.props.hasFilter}
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.Elesson: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <Elesson
                            activityCard={activityCard} classId={this.props.coursePageClassId ? this.props.coursePageClassId : ''}
                        />
                    </div>
                );
            }
            case ActivityType.VirtualClass: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <VirtualClass
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.LinkActivity: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <LinkActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.Forum: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <ForumActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.Project: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <ProjectActivityCard
                            activityCard={activityCard}
                            classId={this.props.coursePageClassId}
                            getActivityCardComponent={this.returnActivityCardComponent}
                        />
                    </div>
                );
            }
            case ActivityType.Exam: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <ExamActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            case ActivityType.InformationNote: {
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <CInformationNoteActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
            }
            default:
                return (
                    <div key={'activity-card-' + activityCard.activityId} className="activity-card-scroll" id={'activity-card-' + activityCard.activityId} >
                        <DefaultActivityCard
                            activityCard={activityCard} classId={this.props.coursePageClassId}
                        />
                    </div>
                );
        }
    }

    changeCourseLoaded = (viewType: any) => {
        if (this.props.classId.courseDefaultView === CourseDefaultViewType.Card) {
            if (viewType === CourseDefaultViewType.List) {
                next_activity_card = [];
            }
            if (this.state.courseDefaultView === CourseDefaultViewType.List) {
                this.setState({ loaded: true })
            }
        }
        else {
            this.setState({ loaded: true })
        }
    }

    changeActivityIcon = (grid_icon: any, list_icon: any) => {
        if (grid_icon && list_icon) {
            grid_icon.className = "active-icons tooltip-container";
            list_icon.className = this.state.showMobile === true ? "tooltip-container" : "tooltip-container";
        }
    }

    changeCourseDefaultView = (viewType: any, callType: string) => {

        if (!this.state.loaded && activity_card_list_view) {
            this.changeCourseLoaded(viewType)

        }
        if (viewType || viewType === 0) {
            this.setState({ courseDefaultView: viewType })
            this.props.dispatch(Actions.setCourseDefaultView(viewType))

            const grid_icon = document.getElementById('active_grid');
            const list_icon = document.getElementById('active_list');
            if (viewType === CourseDefaultViewType.List) {

                if (grid_icon && list_icon) {
                    grid_icon.className = "tooltip-container";
                    list_icon.className = "active-icons " + list_icon.getAttribute("class");
                }
            }
            else {
                this.changeActivityIcon(grid_icon, list_icon)
            }

        }

        if ((callType == "2" || viewType == CourseDefaultViewType.List)) {
            this.props.dispatch(Actions.SetTriggerWeekOnClick(
                "",
                '-1',
                this.props.courseContentMenuType!,
                "",
                this.props.courseContentTermWeeks,
                this.props.hasFilter,
                this.props.coursePageClassId!,
                this.props.coursePageActivityId!,
                this.props.sort,
                this.props.activityFilters,
                this.props.courseContentWeeksActivities,
                viewType,
            ));
            this.setState({ defaultViewClicked: true })
        }
    }



    checkIsChanged = () => {
        if (isChanged) {
            isChanged = false;
        }
    }

    updateActivityCards = () => {
        if (this.props.hasFilter) {
            old_activity_card = activity_card
            old_activity_card_list_view = activity_card_list_view

            activity_card = next_activity_card
            activity_card_list_view = next_activity_card
        }
        else {
            activity_card = old_activity_card
            activity_card_list_view = old_activity_card_list_view
        }
        this.setState({ hasFilterChanged: false })
    }

    handleRenderCards = () => {
        if (next_activity_card) {
            if (this.state.courseDefaultView === CourseDefaultViewType.List && this.state.refreshCardListView) {
                activity_card_list_view = next_activity_card
                this.checkIsChanged();
                this.setState({ refreshCardListView: false })
            }
            else if ((this.state.courseDefaultView === CourseDefaultViewType.Card && this.state.refreshCardView) || this.props.isClickedWeek) {
                activity_card = next_activity_card
                this.checkIsChanged();
                this.props.dispatch(Actions.SetIsClickedWeek(false, "SetIsClickedWeek", "set"));
                this.setState({ refreshCardView: false })

            }
            if (this.state.hasFilterChanged && isChanged) {
                this.updateActivityCards();
            }
        } else {
            activity_card = []
            activity_card_list_view = []
            this.checkIsChanged();
        }

        let render_activityCards = this.state.courseDefaultView === CourseDefaultViewType.List ? activity_card_list_view : activity_card;

        return render_activityCards;
    }

    isFileCheck = (value: any) => {
        this.setState({ isFileExist: value });
    }

    senAssignmentModal = () => {
        return (this.state.isModalOpen ? (
            <BaseModal
                modalIsOpen={this.state.isModalOpen}
                // tslint:disable-next-line: jsx-no-lambda
                onClose={() => this.triggerSendAssignmentModal()}
                headerState={T.t('r_send_assignment_answer')}
                headerIcon={'clock'}
                minWidth={700}
                showHeader={true}
            >
                <SendAssignmentModal fileControl={(e: any) => this.isFileCheck(e)} assignmentActivityCard={this.state.assignmentActivityCard!} callBackFunction={this.callBackFunction} />
            </BaseModal>
        ) : null
        )
    }

    renderUnPlannedHeader = (render_activityCards: any, index: number, week: any) => {
        let unPlannedActivities = render_activityCards.filter((act: any) => (act.dateCriteria !== 1) && ((!act.termWeekIds || (act.termWeekIds && !act.termWeekIds.length)) || (act.termWeeksOnFilter && act.termWeeksOnFilter.length > 0 && (act.termWeeksOnFilter.filter((item: string) => item === "0")).length > 0)));

        return (
            unPlannedActivities && unPlannedActivities.length > 0 ? (
                <div id="activitiesHeader0" className={`my-4 header-scroll ${this.state.showMobile === true ? "col-12" : "col-8"}`} style={{ borderBottom: "1px solid #eceef2", cursor: "pointer" }} onMouseDown={event => this.hideShowActivities(week.termWeekId)}>
                    <div className="row" key={index}>
                        <div className='col-md-9'><b>{T.t('r_gen_unplanned_activity')}</b></div>
                        <div className="col-md-3" style={{ marginBottom: '1%' }}>
                            <button className="material-icons pr-1 pl-1 mb-1" data-event="14" style={{ border: "none", background: "none", float: "inline-end" }}>{this.state.selectedWeeks.includes(week.termWeekId) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</button>
                        </div>
                    </div>
                </div>
            ) : ''
        )
    }

    renderWeekHeaders = (render_activityCards: any, index: number, week: any) => {
        return (
            (
                render_activityCards.find((act: any) => act.termWeekIds?.length && week.termWeekId && act.termWeekIds.indexOf(week.termWeekId) !== -1) ||
                    (this.state.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm && !this.props.hasFilter) ? (
                    <div id={'activitiesHeader' + week.termWeekId} className={`my-4 header-scroll ${this.state.showMobile === true ? "col-12" : "col-8"}`} style={{ borderBottom: "1px solid #eceef2", cursor: "pointer" }} onMouseDown={event => this.hideShowActivities(week.termWeekId)}>
                        <div className="row" key={index}>
                            {T.i18next.language === 'ar'
                                ? <div className='col-md-9 d-flex flex-row-reverse justify-content-end'><span className="font-weight-bold mr-1">{week.week}</span> <span className="font-weight-bold">{week.termType}</span></div>
                                : <div className='col-md-9'><b>{week.termType + " " + week.week}</b></div>
                            }
                            <div className="col-md-3" style={{ marginBottom: '1%' }}>
                                <button className="material-icons pr-1 pl-1 mb-1" data-event="14" style={{ border: "none", background: "none", float: "inline-end" }}>{this.state.selectedWeeks.includes(week.termWeekId) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</button>
                            </div>
                        </div>
                    </div>
                ) : ''
            )
        )
    }

    returnNoContentData = () => {
        return (
            this.state.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm && !this.props.hasFilter ? (
                <div className='col-12 mobile-padding mobile-full-width  card-width'>
                    <div className="create-announcement text-center border-0" style={{ paddingTop: 100 }}>
                        <div className="d-inline-block text-center">
                            <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />
                            <h5
                                id="searched"
                                className="d-block"
                                style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}
                            >
                                {T.t('r_gen_activity_not_found')}
                            </h5>
                            {this.props.userType !== UserType.Student && (<p className='text-center'>{T.t('r_gen_activity_not_found_description')}</p>)}
                        </div>
                    </div>
                </div>
            ) : ''
        )
    }

    hideShowActivities = (weekId: any) => {
        if (this.state.selectedWeeks.includes(weekId)) {

            let array = [...this.state.selectedWeeks];
            let index = array.indexOf(weekId)
            if (index !== -1) {
                array.splice(index, 1);
                this.setState({ selectedWeeks: array });
            }
        }
        else {
            this.setState((prevState: { selectedWeeks: any; }) => ({
                selectedWeeks: [...prevState.selectedWeeks, weekId]
            }));
        }
    }

    // without weeks but for planned activities to appear under weeks function
    checkDateCondition = (activity: any, termWeek: any) => {
        let dateCondition = activity.dateCriteria !== 0 && (activity.beginDate !== null && activity.endDate !== null &&
            (
                ((termWeek.startDate <= activity.beginDate && activity.beginDate <= termWeek.endDate) && (termWeek.startDate <= activity.endDate))
                || ((activity.beginDate <= termWeek.startDate && activity.beginDate <= termWeek.endDate) && (activity.endDate >= termWeek.startDate && activity.endDate <= termWeek.endDate))
                || ((activity.beginDate <= termWeek.startDate && activity.beginDate <= termWeek.endDate) && (activity.endDate >= termWeek.startDate && activity.endDate >= termWeek.endDate))
            )
        )

        return dateCondition;
    }

    returnWeeklyActivities = (render_activityCards: any, week: any,) => {
        let weeklyActivities = render_activityCards.filter((act: any) => act.termWeekIds.indexOf(week.termWeekId) !== -1 || (this.checkDateCondition(act, week)))

        let plannedWeeks = this.props.courseContentTermWeeks?.filter((act: any) => act.termId);
        let plannedWeeksLength = 0;
        if (plannedWeeks) {
            plannedWeeksLength = plannedWeeks.length;

            if (plannedWeeksLength + 2 > this.renderedCount) {
                this.renderedCount++;
            }
        }

        let activityVisibility = "none";
        if (this.state.selectedWeeks.includes(week.termWeekId)) {
            activityVisibility = "block";
        }
        return (

            <div id={'week_' + week.termWeekId} style={{ display: activityVisibility }}>

                {this.returnInside(weeklyActivities, week, plannedWeeksLength)}

            </div>
        )
    }
    returnUnPlannedActivitiesHeader = (unPlannedActivities: any, render_activityCards: any, week: any) => {
        let activityVisibility = "none";
        if (this.state.selectedWeeks.includes(week.termWeekId) || (this.props.hasFilter && unPlannedActivities.length > 0)
            || (!this.state.weeklyTerm && this.props.hasFilter && render_activityCards.length > 0)) {
            activityVisibility = "block";
        }
        return (
            (
                <div id={'week_' + week.termWeekId} style={{ display: activityVisibility }}>
                    {this.renderUnPlannedActivities(unPlannedActivities, render_activityCards)}
                </div>

            ));


    }

    returnInside = (weeklyActivities: any, week: any, plannedWeeksLength: number) => {
        if (weeklyActivities.length > 0 && !this.state.selectedWeeks.includes(week.termWeekId) && plannedWeeksLength >= this.renderedCount) {
            this.setState((prevState: { selectedWeeks: any; }) => ({
                selectedWeeks: [...prevState.selectedWeeks, week.termWeekId]
            }));
        }
        return (
            (
                weeklyActivities.length > 0 ? (
                    (
                        weeklyActivities.map((x: any) => (
                            week.termWeekId === x.activityId.split('_')[1] || x.activityType !== ActivityType.Video || !x.activityId.includes('_') ?
                                this.returnActivityCardComponent(x.activityType, x)
                                : null
                        ))
                    )
                ) : this.returnNoContentData()
            )
        )
    }

    returnHeaders = (week: any, index: any, render_activityCards: any) => {


        if (week.termWeekId !== '0') {
            return this.renderWeekHeaders(render_activityCards, index, week);
        } else {
            return this.renderUnPlannedHeader(render_activityCards, index, week);
        }
    }

    renderWeeklyCoursesActivityCards = (render_activityCards: any) => {
        let unPlannedActivities = render_activityCards.filter((act: any) => (act.dateCriteria !== 1) && ((!act.termWeekIds || (act.termWeekIds && !act.termWeekIds.length)) || (act.termWeeksOnFilter && act.termWeeksOnFilter.length > 0 && (act.termWeeksOnFilter.filter((item: string) => item === "0")).length > 0)));

        if (!this.props.courseContentTermWeeks || this.props.courseContentTermWeeks.length === 0) {
            return '';
        }

        return this.props.courseContentTermWeeks.map((week, index) => {
            return (
                <div key={week.termWeekId} style={{ marginBottom: week.termWeekId === '0' ? "-20px" : "0px" }}>
                    {this.returnHeaders(week, index, render_activityCards)}
                    {week.termWeekId === '0'
                        ? this.returnUnPlannedActivitiesHeader(unPlannedActivities, render_activityCards, week)
                        : this.returnWeeklyActivities(render_activityCards, week)}
                </div>
            );
        });
    }

    renderUnPlannedActivities = (unPlannedActivities: any, render_activityCards: any) => {
        if (unPlannedActivities.length > 0) {
            return unPlannedActivities.map((x: any) => (
                this.returnActivityCardComponent(x.activityType, x)
            ));
        } else if (!this.state.weeklyTerm) {
            return render_activityCards
                .filter((act: any) => act.termWeekIds?.length)
                .map((x: any) => this.returnActivityCardComponent(x.activityType, x));
        } else {
            return null;
        }
    }


    triggerAnnouncementModal = () => {

        let modalOpenStatus = false;
        if (!this.state.isAnnouncementModalOpen) {
            modalOpenStatus = true;
        }

        this.setState({
            isAnnouncementModalOpen: modalOpenStatus
        });
    };

    triggerFilterModal = () => {

        let filterModalOpenStatus = false;
        if (!this.state.filterModalOpen) {
            filterModalOpenStatus = true;
        }

        this.setState({
            filterModalOpen: filterModalOpenStatus
        });
    };


    closeFilterModal = () => {
        this.setState({
            filterModalOpen: false,
            refreshCardListView: false,
            refreshCardView: false

        });
    }


    renderActivityCards = (render_activityCards: any) => {

        if (render_activityCards && render_activityCards.length > 0) {
            if (this.props.hasFilter || (this.state.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm)) {
                return this.renderWeeklyCoursesActivityCards(render_activityCards);
            }
            return (
                <>
                    <div className="col-12" style={{ margin: '12px 0' }}></div>
                    {render_activityCards.map((x: any) => {
                        if (this.props.userType === UserType.Student && x.activeStatus === 0) {
                            return null;
                        }

                        if (this.state.courseDefaultView === CourseDefaultViewType.Card) {
                            const weekOrUnitId = this.props.weekOrUnitId;
                            const isWeekOrUnitIdValid = weekOrUnitId === "-1" || weekOrUnitId === "0" || weekOrUnitId == null;
                            const isTermWeekIdIncluded = x.termWeekIds?.includes(weekOrUnitId);
                            const isTermWeekIdsEmpty = x.termWeekIds.length === 0;
                            if (isTermWeekIdIncluded || isTermWeekIdsEmpty || isWeekOrUnitIdValid) {
                                return this.returnActivityCardComponent(x.activityType, x);
                            } else {
                                return null;
                            }
                        }

                        return this.returnActivityCardComponent(x.activityType, x);
                    })}
                </>
            );
        } else if (this.props.hasFilter) {
            return (
                <div className="create-announcement text-center border-0 text-center" style={{ paddingTop: 100 }}>
                    <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />
                    <h5 id="searched" className="d-block" style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}>
                        {T.t('r_gen_activity_not_found')}
                    </h5>
                    {this.props.userType !== UserType.Student && (
                        <p className='text-center'>{T.t('r_gen_activity_not_found_description')}</p>
                    )}
                </div>
            );
        } else {
            return null;
        }
    }


    viewActivityVisibility = (weekValue: any) => {
        let activityVisibility = "none";
        if (this.state.selectedWeeks.includes(weekValue)) {
            activityVisibility = "block";
        }

        return activityVisibility;
    }
    onClickRefresh = () => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_REFRESH_CLICKED',
            label: 'G_REFRESH_CLICKED',
            nonInteraction: true,
        });
        coursePageService.RequestClearCourseCacheData({ ClassId: this.props.coursePageClassId ? this.props.coursePageClassId : '0', CourseId: this.props.coursePageActivityId ? this.props.coursePageActivityId : '0' });
        this.props.dispatch(EnrollmentActions.enrollmentGetAction(this.props.coursePageClassId ? this.props.coursePageClassId : '0'));
        this.onFilter();
        this.props.dispatch(Actions.setPassiveButton(false))
    };


    onFilter = (statusType?: string) => {
        clearTimeout(this.delayTimer);

        if (!statusType) {
            this.setState({ isLoading: true });
        }

        this.delayTimer = setTimeout(() => {
            if (this.props.coursePageClassId && this.props.coursePageActivityId) {
                const _filters = this.state.filters;
                this.onFilterGetActivitiesOptions(_filters);
            }
        }, 2000);

        if (this.state.isFirstLoad) {
            this.setState({ isFirstLoad: false });
            this.filterOnSwitchListView()
        }
    };
    hasFilter = () => {
        if (this.state.filters && (this.state.filters.searchedText || (this.state.filters.selectedActivityTypes && this.state.filters.selectedActivityTypes.length > 0))) {
            return true;

        }
        else {
            return false;
        }
    }
    public getActivitiesCallback = () => {
        this.props.dispatch(Actions.getActivityIdsByWeeks(this.props.coursePageClassId!, '', false, 'getActivityIdsByWeeks', 'get', undefined, false, this.props.coursePageActivityId ?? ""))
    }
    onFilterGetActivitiesOptions = (_filters: any) => {
        if ((this.props.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm) || (this.state.filters && (this.state.filters.searchedText || (this.state.filters.selectedActivityTypes && this.state.filters.selectedActivityTypes.length > 0)))) {
            _filters.hasFilter = this.hasFilter();
            _filters.sort = this.props.sort!;
            this.setState({ filters: _filters, isLoading: false });
            const param: IActivityCard = {
                actId: '',
                coursePageClassId: this.props.coursePageClassId,
                coursePageActivityId: this.props.coursePageActivityId,
                courseContentTermWeeks: this.props.courseContentTermWeeks,
                hasFilter: _filters.hasFilter,
                activityFilters: _filters,
                GetOnlyPassiveList: this.state.filters.GetOnlyPassiveList ? this.state.filters.GetOnlyPassiveList : false,
                weekOrUnitId: '-1',
                courseContentMenuType: this.props.courseContentMenuType,
                sort: this.props.sort!,
                activeStatus: this.state.statusFilter,
                courseContentWeekActivities: this.props.courseContentWeeksActivities
            };
            this.props.dispatch(Actions.SetTriggerGetActivities(param, undefined, "SetTriggerGetActivities", 'get', this.props.courseDefaultView));

        } else {
            _filters.hasFilter = false;
            _filters.sort = this.props.sort!;
            this.setState({ filters: _filters, isLoading: false });
            const param: IActivityCard = {
                actId: '',
                coursePageClassId: this.props.coursePageClassId,
                coursePageActivityId: this.props.coursePageActivityId,
                courseContentTermWeeks: this.props.courseContentTermWeeks,
                hasFilter: _filters.hasFilter,
                activityFilters: _filters,
                GetOnlyPassiveList: this.state.filters.GetOnlyPassiveList ? this.state.filters.GetOnlyPassiveList : false,
                weekOrUnitId: this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId,
                courseContentMenuType: this.props.courseContentMenuType,
                courseContentWeekActivities: this.props.courseContentWeeksActivities,
                sort: this.props.sort!
            };

            this.props.dispatch(Actions.SetTriggerGetActivities(param, this.getActivitiesCallback, "SetTriggerGetActivities", 'get', this.props.courseDefaultView, this.state.nonWeeklyCourse));

            this.props.dispatch(Actions.getCourseContentsWeekActivitiesAction(
                this.props.coursePageClassId!,
                this.props.coursePageActivityId!,
                false,
                0,
                1000,
                this.props.weekOrUnitId === '0' ? '-1' : this.props.weekOrUnitId!,
                false,
                false,
                null,
                'contentWeekActivities',
                'get',
                false,
                this.props.sort!));
        }
    }
    filterOnSwitchListView = () => {
        if (this.props.courseDefaultView === CourseDefaultViewType.List && this.state.weeklyTerm) {
            const param: IActivityCard = {
                actId: '',
                coursePageClassId: this.props.coursePageClassId,
                coursePageActivityId: this.props.coursePageActivityId,
                courseContentTermWeeks: this.props.courseContentTermWeeks,
                hasFilter: false,
                activityFilters: this.state.filters,
                GetOnlyPassiveList: this.state.filters.GetOnlyPassiveList ? this.state.filters.GetOnlyPassiveList : false,
                weekOrUnitId: '-1',
                courseContentMenuType: this.props.courseContentMenuType,
                sort: this.props.sort!,
                activeStatus: this.state.statusFilter,
                courseContentWeekActivities: this.props.courseContentWeeksActivities
            };

            this.props.dispatch(Actions.SetTriggerGetActivities(param, undefined, "SetTriggerGetActivities", "get", CourseDefaultViewType.List));
        }
    }
    onFilterByStatus = (status: boolean) => {
        ReactGA.event({
            category: window.location.host,
            action: 'G_SHOW_PASSIVES_CLICKED',
            label: 'G_SHOW_PASSIVES_CLICKED',
            nonInteraction: true,
        });

        const _filters = this.state.filters;
        _filters.GetOnlyPassiveList = status;
        this.setState({ filters: _filters });

        this.onFilter("filterByStatus");
    };
    renderNonLesson = () => {

        let divResult = [] as any;
        if (this.props.courseContentMenuType) {
            if (this.state.courseDefaultView === CourseDefaultViewType.List && !this.state.filterData.hasFilter) {
                this.props.courseContentTermWeeks?.filter(function (value) {
                    return value.termId != null;
                }).map((value) => {
                    let activityVisibility = this.viewActivityVisibility(value.week);

                    divResult.push(<div style={{ marginBottom: "0px" }} key={value.termWeekId}><div id={'activitiesHeader' + value.week} className={`my-4 header-scroll ${this.state.showMobile === true ? "col-12" : "col-8"}`} style={{ borderBottom: "1px solid #eceef2", cursor: "pointer" }} onMouseDown={event => this.hideShowActivities(value.week)}>
                        <div className="row" key={value.week}>
                            {T.i18next.language === 'ar'
                                ? <div className='col-md-9 d-flex flex-row-reverse justify-content-end'><span className="font-weight-bold mr-1">{value.week}</span> <span className="font-weight-bold">{value.termType}</span></div>
                                : <div className='col-md-9'><b>{value.termType + " " + value.week}</b></div>
                            }
                            <div className="col-md-3" style={{ marginBottom: '1%' }}>
                                <button className="material-icons pr-1 pl-1 mb-1" data-event="14" style={{ border: "none", background: "none", float: "inline-end" }}>{this.state.selectedWeeks.includes(value.week) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</button>
                            </div>
                        </div>

                    </div><div id={'week_' + value.week} style={{ display: activityVisibility }}>

                            {this.returnNoContentData()}
                        </div></div>)
                })
            }
            else {
                divResult.push(<div className='col-12 mobile-padding mobile-full-width  card-width'>
                    <div className="create-announcement text-center border-0" style={{ paddingTop: 100 }}>
                        <div className="d-inline-block text-center">
                            <img style={{ marginTop: '2em', marginBottom: '1em' }} src={imgAnn} />
                            <h5
                                id="searched"
                                className="d-block"
                                style={{ marginTop: 15, textAlign: 'center', marginBottom: 15 }}
                            >
                                {T.t('r_gen_activity_not_found')}
                            </h5>
                            {this.props.userType !== UserType.Student && (<p className='text-center'>{T.t('r_gen_activity_not_found_description')}</p>)}
                        </div>
                    </div>
                </div>)
            }
        }

        return divResult
    }

    setWeeklyTerm = () => {
        if (this.props.courseContentTermWeeks && this.props.courseContentTermWeeks?.length <= 1) {
            if (this.state.weeklyTerm) {
                this.setState({ weeklyTerm: false })
            }
        }
        else {
            if (!this.state.weeklyTerm) {
                this.setState({ weeklyTerm: true })
            }
        }
    }

    public render() {


        this.setWeeklyTerm();
        let render_activityCards = this.handleRenderCards();
        return (
            <React.Fragment>
                {
                    this.state.showMobile === true && this.props.courseContentTermWeeks &&
                    <div className='mobile-weeker' style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div style={{ zIndex: 0, margin: 0, display: 'flex' }}>
                            <CourseContentSelectionMenu showMobile={window.innerWidth <= 1024} />
                        </div>
                        {
                            (this.state.weeklyTerm && this.state.rendered) &&
                            <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginRight: 0, gap: '.5em' }}>
                                <Tooltip data={T.t('r_course_card_view')} position='bottom'>

                                    <a id='active_grid'
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.changeCourseDefaultView(CourseDefaultViewType.Card, "1")
                                            }
                                        }}
                                        onClick={() => this.changeCourseDefaultView(CourseDefaultViewType.Card, "1")}>
                                        <img width={24} height={24} src={_common.GetDefaultIcons('displaygrid')} alt="" />

                                    </a>
                                </Tooltip>
                                <Tooltip data={T.t('r_course_list_view')} position='bottom'>
                                    <a id='active_list'
                                        onKeyDown={event => {
                                            if (event.key === 'Enter') {
                                                this.changeCourseDefaultView(CourseDefaultViewType.List, "2")
                                            }
                                        }}
                                        onClick={() => this.changeCourseDefaultView(CourseDefaultViewType.List, "2")}>

                                        <img width={24} height={24} src={_common.GetDefaultIcons('displaylist')} alt="" />

                                    </a>
                                </Tooltip>
                            </div>
                        }
                    </div>

                }
                {!this.props.isSimulate
                    && (
                        <BaseModal
                            minWidth={1100}
                            modalIsOpen={this.state.isAnnouncementModalOpen}
                            onClose={this.triggerAnnouncementModal}
                            headerState={this.state.modalHeaderData}
                            headerIcon={'clock'}
                            showHeader={true}
                        >
                            <LoginAnnouncementModal onClickChangeAnnouncement={this.triggerAnnouncementModal} headerState={this.headerState} leftAnnouncementCount={0} />
                        </BaseModal>
                    )
                }

                {this.senAssignmentModal()}
                <div className="col-md-3 mobile_display_course_filter tablet-display" style={{ float: 'inline-end', maxWidth: '31%', zIndex: 0, position: 'relative', backgroundColor: '#fff', scrollBehavior: 'smooth', overflowY: 'auto', paddingTop: '0px !important', height: 'auto', top: '0' }}>
                    <ActivityFilters loaded={this.state.loaded} onFilter={this.onFilter} />
                    {
                        this.props.classes.classes.length > 0 &&
                        <CInComingActivities />
                    }
                    {this.props.moduleItems?.includes(ModuleItems.Announcement) &&
                        <CAnnouncements triggerAnnouncementModal={this.triggerAnnouncementModal} />
                    }

                    {this.props.userType && this.props.userType !== UserType.Student ? ' ' : <CActivityProgress />}


                </div>
                <Loading spinnerId={'spinnerIdWeekA'}>
                    <div style={{ marginTop: 24, paddingTop: 24 }}>
                        <div className="col-lg-8">
                            <ContentLoader
                                speed={2}
                                width={730}
                                height={312}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 730 312"
                                style={{ width: '100%' }}
                                id={'activityContentLoading'}
                            >
                                <rect x="103" y="69" rx="0" ry="0" width="314" height="14" />
                                <rect x="103" y="101" rx="0" ry="0" width="314" height="14" />
                                <circle cx="650" cy="88" r="20" />
                                <rect x="2" y="152" rx="0" ry="0" width="249" height="132" />
                                <rect x="3" y="65" rx="0" ry="0" width="88" height="63" />
                                <rect x="270" y="156" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="189" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="226" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="261" rx="0" ry="0" width="394" height="14" />

                            </ContentLoader>
                        </div>
                        <div className="col-lg-8">
                            <ContentLoader
                                speed={2}
                                width={730}
                                height={312}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 730 312"
                                style={{ width: '100%' }}
                            >
                                <rect x="103" y="69" rx="0" ry="0" width="314" height="14" />
                                <rect x="103" y="101" rx="0" ry="0" width="314" height="14" />
                                <circle cx="650" cy="88" r="20" />
                                <rect x="2" y="152" rx="0" ry="0" width="249" height="132" />
                                <rect x="3" y="65" rx="0" ry="0" width="88" height="63" />
                                <rect x="270" y="156" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="189" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="226" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="261" rx="0" ry="0" width="394" height="14" />

                            </ContentLoader>
                        </div>
                        <div className="col-lg-8">
                            <ContentLoader
                                speed={2}
                                width={730}
                                height={312}
                                backgroundColor="#f3f3f3"
                                foregroundColor="#ecebeb"
                                viewBox="0 0 730 312"
                                style={{ width: '100%' }}
                            >
                                <rect x="103" y="69" rx="0" ry="0" width="314" height="14" />
                                <rect x="103" y="101" rx="0" ry="0" width="314" height="14" />
                                <circle cx="650" cy="88" r="20" />
                                <rect x="2" y="152" rx="0" ry="0" width="249" height="132" />
                                <rect x="3" y="65" rx="0" ry="0" width="88" height="63" />
                                <rect x="270" y="156" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="189" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="226" rx="0" ry="0" width="394" height="14" />
                                <rect x="270" y="261" rx="0" ry="0" width="394" height="14" />

                            </ContentLoader>
                        </div>
                    </div>
                </Loading>
                <div id="spinnerIdWeekA_Content">
                    {(this.state.rendered) &&
                        <div className="header mobile-none" style={{ margin: '12px 0', textAlignLast: 'right' }}>
                            <div className='activity_toggle' >
                                <div style={{ justifyContent: "space-between", display: "flex" }}>
                                    <div className='col-6' style={{ display: "inline-flex" }}>
                                        {this.props.userType !== UserType.Student && (
                                            <Button
                                                button_type={this.state.filters?.GetOnlyPassiveList ? "primary" : "secondary"}
                                                size='small'
                                                text={T.t('r_show_passive_activities')}
                                                onClick={() => this.onFilterByStatus(!this.state.filters?.GetOnlyPassiveList)}
                                                onKeyDown={(event: React.KeyboardEvent) => {
                                                    if (event.key === 'Enter') {
                                                        this.onFilterByStatus(!this.state.filters?.GetOnlyPassiveList);
                                                    }
                                                }}
                                            />
                                        )}


                                        <Button
                                            button_type='secondary'
                                            size='small'
                                            style={{ minWidth: "170px", maxWidth: "180px", width: "100%" }}
                                            text={this.state.isLoading ? (
                                                <div id="loading-bar-spinner" className="spinner"><div className="spinner-icon" /></div>
                                            ) : T.t('r_refresh_activities')}
                                            onClick={this.onClickRefresh}
                                            onKeyDown={(event: React.KeyboardEvent) => {
                                                if (event.key === 'Enter') {
                                                    this.onClickRefresh();
                                                }
                                            }}
                                        />
                                    </div>
                                    {(this.state.weeklyTerm && this.state.rendered) &&
                                        <div className='col-6 d-flex justify-content-end'>
                                            <Tooltip data={T.t('r_course_card_view')} position='bottom'>
                                                <a id='active_grid'
                                                    onKeyDown={event => {
                                                        if (event.key === 'Enter') {
                                                            this.changeCourseDefaultView(CourseDefaultViewType.Card, "1")
                                                        }
                                                    }}
                                                    onClick={() => this.changeCourseDefaultView(CourseDefaultViewType.Card, "1")} style={{ padding: '1px 8px 5px 8px', cursor: 'pointer' }} tabIndex={0}>

                                                    <img width={24} height={24} src={_common.GetDefaultIcons('displaygrid')} alt="" />

                                                </a>
                                            </Tooltip>
                                            <Tooltip data={T.t('r_course_list_view')} position='bottom'>
                                                <a id='active_list' tabIndex={0} style={{ padding: '1px 8px 5px 8px', cursor: 'pointer' }}
                                                    onKeyDown={event => {
                                                        if (event.key === 'Enter') {
                                                            this.changeCourseDefaultView(CourseDefaultViewType.List, "2")
                                                        }
                                                    }}
                                                    onClick={() => this.changeCourseDefaultView(CourseDefaultViewType.List, "2")}>
                                                    <img width={24} height={24} src={_common.GetDefaultIcons('displaylist')} alt="" />

                                                </a>
                                            </Tooltip>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>

                    }
                    {(this.renderActivityCards(render_activityCards) != null)
                        ?
                        (this.renderActivityCards(render_activityCards))
                        :
                        this.renderNonLesson()
                    }
                </div>
                <div className='col-12' onMouseDown={this.triggerFilterModal}>
                    <a className="filterbtn notification-filter" tabIndex={0}>
                        <span className="material-icons">
                            tune
                        </span>
                        {this.state.filterData?.filter?.selectedActivityTypes?.length > 0 && (
                            <span className="count">{this.state.filterData?.filter?.selectedActivityTypes.length}</span>
                        )}
                    </a></div>
                {this.state.filterModalOpen && (
                    <FilterModal
                        isProjectSubActivity={this.props!}
                        modalIsOpen={true}
                        onClose={this.closeFilterModal}
                        updateFilterData={this.updateFilterData}
                        filterData={this.state.filterData} />
                )}
            </React.Fragment>
        );
    }
}
// spinnerIdWeekA
const mapStateToProps = (state: IAppState, ownProps: IActivityCard): IActivityCard => {
    if (!state) {
        return ownProps;
    }

    const newProps: IActivityCard = Object.assign({}, ownProps, {
        activityCard: state.coursePage.activityCard,
        // courseContentActivityCardLoading: state.coursePage.courseContentActivityCardLoading,
        userType: state.login.identitiy.userType,
        deleteActivityLoading: state.coursePage.deleteActivityLoading,
        deletedActivityId: state.coursePage.deletedActivityId,
        courseContentMenuType: state.coursePage.courseContentMenuType,
        courseContentTermWeeks: state.coursePage.courseContentTermWeeks,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        coursePageClassId: state.coursePage.coursePageClassId,
        actId: state.coursePage.actId,
        courseContentWeekActivities: state.coursePage.courseContentWeekActivities,
        weekOrUnitId: state.coursePage.weekOrUnitId,
        enrollmentData: state.enrollment.enrollmentData,
        isGettingWeeks: state.coursePage.isGettingWeeks,
        activityIdAfterAdd: state.coursePage.activityIdAfterAdd,
        termWeeksOnFilter: state.coursePage.termWeeksOnFilter,
        activityFilters: state.coursePage.activityFilters,
        hasFilter: state.coursePage.hasFilter,
        sort: state.coursePage.courseSortingKey,
        classId: state.coursePage.coursePageclassInformation,
        isTriggerGetActivities: state.coursePage.isTriggerGetActivities,
        isClickedWeek: state.coursePage.isClickedWeek,
        getMoreActivities: state.coursePage.getMoreActivities,
        courseDefaultView: state.coursePage.courseDefaultView,
        courseContentWeeksActivities: state.coursePage.courseContentWeekActivities,
        classes: state.coursePage.classes,
        isSimulate: state.login.identitiy.isSimulate,
        moduleItems: state.login.login.moduleItems,
    });
    return newProps;
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return ({
        dispatch
    });
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    const ret = (
        next.coursePage.courseContentTermWeeks === prev.coursePage.courseContentTermWeeks &&
        next.coursePage.activityCard === prev.coursePage.activityCard &&
        next.coursePage.actId === prev.coursePage.actId &&
        next.coursePage.weekOrUnitId === prev.coursePage.weekOrUnitId &&
        next.enrollment.enrollmentData === prev.enrollment.enrollmentData &&
        next.coursePage.isGettingWeeks === prev.coursePage.isGettingWeeks &&
        next.coursePage.courseContentMenuType === prev.coursePage.courseContentMenuType &&
        next.coursePage.activityIdAfterAdd === prev.coursePage.activityIdAfterAdd &&
        next.coursePage.termWeeksOnFilter === prev.coursePage.termWeeksOnFilter &&
        next.coursePage.activityFilters === prev.coursePage.activityFilters &&
        next.coursePage.hasFilter === prev.coursePage.hasFilter &&
        next.coursePage.courseSortingKey === prev.coursePage.courseSortingKey &&
        next.coursePage.courseContentWeekActivities === prev.coursePage.courseContentWeekActivities &&
        next.coursePage.isClickedWeek === prev.coursePage.isClickedWeek &&
        next.coursePage.getMoreActivities === prev.coursePage.getMoreActivities &&
        next.coursePage.classes === prev.coursePage.classes
    );

    if (next.coursePage.activityCard !== prev.coursePage.activityCard) {
        next_activity_card = next.coursePage.activityCard
        isChanged = true
    }

    return ret;
};

const CActivityCardContainer = connect(
    mapStateToProps,
    dispatchProps,
    null,
    {
        areStatesEqual,
    }
)(ActivityCardContainer);

export default CActivityCardContainer;
